jQuery(function($){
  var input = $( ".inputshopify" );
  $.each(input, function(i, item){
    if($(item).val()) $(item).parent(".wrapinputshopify").addClass('show-input');
  })
  input.focus(function(){
    $(this).parent(".wrapinputshopify").addClass('show-input');
  }).focusout(function(){
    if($(this).val() == ''){
      $(this).parent(".wrapinputshopify").removeClass('show-input');
    }
  })
});  


(function($){
  "use strict";
  
  /* widget Toggle*/
function JVwidgetToggle() {    
  $(".widget-toggle .widget-title").click(function(){
    
    if($(this).hasClass('widget-hide-content')){
 		$(this).next('.content-widget').slideToggle(300);
    	$(this).removeClass('widget-hide-content');
    }else{
 		$(this).next('.content-widget').slideToggle(300);
    	$(this).addClass('widget-hide-content');      
 
    };  
      
  });
  }
  JVwidgetToggle();
  window.JVwidgetToggle = JVwidgetToggle;  

  
  /* Simple Gallery */
function JVSimpleGallery() {     
	$('.product-item').each(function(i, item){
		var thumbs = $(item).find('.small-thumbnail');
		thumbs.each(function(j , a){
			$(a).click(function(){
				$(item).find('.medium-thumbnail').attr('src', $(a).attr('href'));
				return false;
			})
		})
	})  
  }
  JVSimpleGallery();
  window.JVSimpleGallery = JVSimpleGallery;  

  /* search */
  var $body= $('body');
  $('.button-search').click(function(){
    if($body.hasClass('show-search')){
      $body.removeClass('show-search');
    }else{
      $body.addClass('show-search');
    }
  });				

  /* tooltip */
  function JVtooltip() {  
    $('[data-toggle="tooltip"]').tooltip(); 
  }
  JVtooltip();
  window.JVtooltip = JVtooltip;  

  $('[data-toggle="popover"]').on('click', function(e){ e.preventDefault();}).popover(); 



  /* Parallax  */
  var $window = $(window); 
  var GSparallax = function(){
    if ($window.width() > 768) {
      $window.stellar({
        horizontalScrolling: false,
        verticalOffset: 40
      });
    }
  };

  GSparallax();

  /* ScrollToFixed menu */
  //$('.fixed-header').scrollToFixed({minWidth: 768});
  $('.fixed-header').scrollToFixed();






  /////////////////////// owl Slider

  jQuery.fn.owlCarousel && jQuery(function($) {


    function JVmasonryslider() {
    $(document).ready(function() {
     
      $(".product-img .thumbnail-slider ").owlCarousel({
         

    animateOut: 'slideOutDown',
    animateIn: 'flipInX',
    items:1,
    margin:30,
    stagePadding:30,
    smartSpeed:450
                                                       
      });
     
    });      

        
    }

    JVmasonryslider();
  	window.JVmasonryslider = JVmasonryslider;  
    
    
    




    

    $('.slider-products-1 .mainslider').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
        singleItem: true,
        pagination: false,
        navigation: false,
        navigationText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
        autoPlay: true,
        transitionStyle: 'fade'
      });
    });      
    $('.slider-products-2 .mainslider').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
        items: 2,
        pagination: false,
        navigation: true,
        navigationText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
        autoPlay: false,
        itemsDesktopSmall: [1199, 2],
        itemsTablet: [768, 2]
      });
    });      
    $('.slider-products-3 .mainslider').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
        items: 3,
        pagination: false,
        navigation: true,
        navigationText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
        autoPlay: false,
        itemsDesktopSmall: [1199, 3]
      });
    });      
    $('.slider-products-4 .mainslider').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
        loop:false,
        margin:10,
        nav:true,
        navText: ["",""],
        responsive:{
          0:{
            items:1
          },
          600:{
            items:3
          },
          1000:{
            items:4
          }
        } 

      });



    });      
    $('.slider-products-5 .mainslider').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
       
        items: 5,
        pagination: false,
        navigation: true,
        navigationText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
        autoPlay: false
        
       
      });
    });      
    $('.slider-products-6 .mainslider').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
        items: 6,
        pagination: false,
        navigation: true,
        navigationText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
        autoPlay: false
      });
    });      


    $('.logoSlider ').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
        items: 6,
        pagination: false,
        navigation: false,
        navigationText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
        autoPlay: true,
        itemsDesktopSmall: [1199, 4],
        itemsTablet: [991, 3],
        itemsMobile: [479, 2]
      });
    });

    $('.advertisement').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
        loop:true,
        animateOut: 'slideOutDown',
        animateIn: 'flipInX',
        nav:true,
        navText: ["",""],
        items:1,
        margin:0,
        stagePadding:0,
        smartSpeed:450  
      });
    });

    $('.list-vendor-slider').hide().imagesLoaded(function() {
      $(this).show().owlCarousel({
        
        margin:10,
        autoWidth:true,
        autoplay:true,
        autoplayTimeout:1000
      });
    });    


    
    
  });



})(jQuery);	



(function($){
  $(document).ready(function(){
    /**
     * Progress bar
     */
    function JvProgressbar($container) {
      $container.find('.progressbar').progressbar({display_text: 'center'});
    }

    /**
     * Active Progress bar
     */
    function JvProgressbarActive() {
      $('.progressbar-wrapper').each(function () {
        var $this = $(this);
        $this.waypoint({
          handler: function (direction) {
            JvProgressbar($this);
          },
          offset: "68%"
        });
      })
    }

    JvProgressbarActive();

    /**
     * Piechart
     */
    function JvPiechart() {
      $('.piechart').each(function () {
        var $this = $(this);
        var value = Number($this.data("value")) / 100;
        var option;

        if ($this.hasClass('piechart-icon')) {
          option = {
            strokeWidth: 6,
            trailWidth: 6,
            duration: 1500,
            easing: 'bounce'
          };
        }
        else {
          option = {
            strokeWidth: 5,
            trailWidth: 5,
            duration: 1500,
            easing: 'bounce',
            text: {
              value: '0%'
            },
            step: function (state, bar) {
              bar.setText((bar.value() * 100).toFixed(0) + "%");
            }
          }
        }

        var circle = new ProgressBar.Circle($(this)[0], option);

        $this.waypoint({
          handler: function (direction) {
            circle.animate(value);
          },
          offset: "68%"
        });

      });

    }

    JvPiechart();


    /**
     * Count To
     */
    var $window = $(window);  
    function JvCountTo() {
      $('.counter-group').each(function (index) {
        var $this = $(this);
        $window.on('scroll', function () {
          var WindowToTop = $window.scrollTop();
          var itemToTop = $this.offset().top;
          if (WindowToTop + $window.height() > itemToTop + $this.height()) {
            $this.find('.timer:not(.counted)').countTo().addClass('counted');
          }
        });
      });
    }
    JvCountTo();     

    /**
     * Count Down
     */

       
    function JVcountdown() {    
      if($('.hotdeal-countdown').length>0){
        $(".hotdeal-countdown").TimeCircles({
          animation: "smooth",
          fg_width: 0.04,
          bg_width: 1,
          text_size: 0,
          circle_bg_color: "#1b1d1f",
          time: {
          Days: {
          show: true,
          text: "Dates",
          color: "#ff0000"
        },
                                            Hours: {
                                            show: true,
                                            text: "Hours",
                                            color: "#31aae2"
                                            },
                                            Minutes: {
                                            show: true,
                                            text: "Minutes",
                                            color: "#f9ea0d"
                                            },
                                            Seconds: {
                                            show: true,
                                            text: "Seconds",
                                            color: "#ffffff"
                                            }
                                            }
                                            }); 
      } }
    JVcountdown();
    window.JVcountdown = JVcountdown;  

    


  });	


  /**
     * Ajax Cart 
     */


  $(document).ready(function() {
    t.go()
    console.log("a")
  });
  $(window).resize(function() {


    t.goResizeImage()
  });



  var t = window.initAjaxProduct = {
    atTimeout: null,
    isSidebarAjaxClick: false,
    go: function() {
      this.goResizeImage();
      this.goMiniCart();//add cart
      this.goAddToCart();
      this.goBox();
      this.goWishlist();

    },



    goMiniCart: function() {
      $("#mini-cart .btn-remove").click(function(n) {
        n.preventDefault();
        var cart = $(this).parents(".mini_cart_item").attr("id");
        cart = cart.match(/\d+/g);
        Shopify.removeItem(cart, function(e) {
          t.doUpdateMiniCart(e)
        })
      })
    },

    checkItemsInMiniCart: function() {
      if ($("#mini-cart .cart-list").children().length > 0) {
        $("#mini-cart").removeClass('mini_cart_hidden')
      } else {
        $("#mini-cart").addClass('mini_cart_hidden')
      }
    },      


    goWishlist: function() {
      $(".product-item button.wishlist").click(function(n) {
        n.preventDefault();
        var r = $(this).parent();
        var i = r.parents(".product-item");
        $.ajax({
          type: "POST",
          url: "/contact",
          data: r.serialize(),
          beforeSend: function() {
            t.showLoading()
          },
          success: function(n) {
            t.hideLoading();
            r.html('<a class=" btn btn-lg wishlist-added wishlist icon-heart7" href="/pages/wishlist" data-toggle="tooltip" data-placement="bottom" title="Go to wishlist"></a>');
            $(".ajax-success-cbox").find(".show-wishlist").show();
            $(".ajax-success-cbox").find(".show-cart").hide();
            t.showBox(".ajax-success-cbox")
          },
          error: function(n, r) {
            t.hideLoading();
            $("body").removeClass('ajaxing')
            $(".ajax-error-message").text($.parseJSON(n.responseText).description);
            t.showBox(".ajax-error-cbox")
          }
        })
      })
    },


    goResizeImage: function() {
      if (window.product_image_resize) {
        $(".product-image img").fakecrop({
          fill: window.images_size.is_crop,
          widthSelector: ".grid-item .product-image",
          ratioWrapper: window.images_size
        })
      }
    },



    showBox: function(n) {
      $(n).addClass('slideInUp');
      t.atTimeout = setTimeout(function() {
        $(n).removeClass('slideInUp');
      }, 5e3)
    },


    goBox: function() {
      $(".close-cbox").click(function() {
        clearTimeout(t.atTimeout);
        $(".ajax-success-cbox").fadeOut(500)
      })
    },



    goAddToCart: function() {
      if ($(".add-to-cart-btn").length > 0) {
        $(".add-to-cart-btn").click(function(n) {
          n.preventDefault();
          if ($(this).attr("disabled") != "disabled") {
            var cart = $(this).parents(".product-item");
            var i = $(cart).data("id");
            var form = $(this).parents('form');


            i = i.match(/\d+/g);
            if (!window.ajax_cart) {
              form.submit();
            } else {
              var s = form.find("select[name=id]").val();
              if (!s) {
                s = form.find("input[name=id]").val();
              }
              var o = form.find("input[name=quantity]").val();
              if (!o) {
                o = 1
              }
              var u = $(cart).find(".product-title").text();
              t.doAjaxAddToCart(s, o, u)
            }

          }
          return false
        })
      }
    },
    showLoading: function() {
      $("body").addClass('ajaxing')
    },
    hideLoading: function() {
      $("body").removeClass('ajaxing')
    },
    doAjaxAddToCart: function(n, r, i, s) {
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: "quantity=" + r + "&id=" + n,
        dataType: "json",
        beforeSend: function() {
          t.showLoading()
        },
        success: function(n) {
          t.hideLoading();
          $(".ajax-success-cbox").find(".ajax-product-title").text(i);
          $(".ajax-success-cbox").find(".show-wishlist").hide();
          $(".ajax-success-cbox").find(".show-cart").show();
          t.showBox(".ajax-success-cbox");
          t.updateMiniCart()
        },
        error: function(n, r) {
          t.hideLoading();
          $(".ajax-error-message").text($.parseJSON(n.responseText).description);
          t.showBox(".ajax-error-cbox")
        }
      })
    },

    updateMiniCart: function() {
      Shopify.getCart(function(e) {
        t.doUpdateMiniCart(e)
      })
    },
    doUpdateMiniCart: function(n) {
      $("#cart-count").text(n.item_count);
    },


    updateMiniCart: function() {
      Shopify.getCart(function(e) {
        t.doUpdateMiniCart(e)
      })
    },
    doUpdateMiniCart: function(n) {
      var cart = '<li class="mini_cart_item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-inner"><a href="javascript:void(0)" title="Remove Item" class="btn-remove"><i class=" icon-delete-outline"></i></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral"><span class="price">{PRICE}</span>(x {QUANTITY})</div></div></li>';
      $("#cart-count").text(n.item_count);
      $("#mini-cart .summary .price").html(Shopify.formatMoney(n.total_price, window.money_format));
      $("#mini-cart .cart-list").html("");
      if (n.item_count > 0) {
        for (var i = 0; i < n.items.length; i++) {
          var s = cart;
          s = s.replace(/\{ID\}/g, n.items[i].id);
          s = s.replace(/\{URL\}/g, n.items[i].url);
          s = s.replace(/\{TITLE\}/g, n.items[i].title);
          s = s.replace(/\{QUANTITY\}/g, n.items[i].quantity);
          s = s.replace(/\{IMAGE\}/g, Shopify.resizeImage(n.items[i].image, "small"));
          s = s.replace(/\{PRICE\}/g, Shopify.formatMoney(n.items[i].price, window.money_format));
          $("#mini-cart .cart-list").append(s)
        }
        $("#mini-cart .btn-remove").click(function(n) {
          n.preventDefault();
          var cart = $(this).parents(".mini_cart_item").attr("id");
          cart = cart.match(/\d+/g);
          Shopify.removeItem(cart , function(e) {
            t.doUpdateMiniCart(e)
          })
        })
      }
      t.checkItemsInMiniCart()

    }

    //endcart

  }







  })(jQuery);